import {apiGlobal} from './index'
import {LOCAL_STORAGE} from '@utils/Const'

const getAccessToken = () => localStorage.getItem(LOCAL_STORAGE.ACCESS_TOKEN)

const reviseEndPoint = {
  AUDIO_MESSAGES: 'iesv/api/v1/ielts/conversations/audio-messages',
  SPEECH_CHECK: 'iesv/api/v1/check/speech',
  GET_QUANTITIES: 'iesv/api/v1/knowledge-notebook-practices/phrases/quantities', // lấy số lượng từ cần ôn
  GET_PHRASES_TODAY:
    'iesv/api/v1/knowledge-notebook-practices/phrases/overview', // lấy danh sách từ cần ôn trong ngày
  GET_Questions: 'iesv/api/v1/knowledge-notebook-practices/phrases/questions', // lấy dữ liệu câu hỏi
  SEND_QUESTION_HISTORIES:
    'iesv/api/v1/knowledge-notebook-practices/phrases/users/practice-histories', // gửi dữ liệu đã ôn và lấy dữ liệu tổng kết
  RETRIEVE_TEXTS: 'iesv/api/v1/knowledge-notebook-practices/retrieve-texts', // Lấy text khi thu âm
  CHECK_USER_ANSWERS:
    'iesv/api/v1/knowledge-notebook-practices/phrases/check-user-answers', // Kiểm tra kết quả câu trà lời
}

const reviseRequest = {
  getSpeechCheck: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authPost(reviseEndPoint.SPEECH_CHECK, params, {}, true)
    }
  },
  getQuantities: () => {
    if (getAccessToken()) {
      return apiGlobal.authGet(reviseEndPoint.GET_QUANTITIES, {})
    }
  },
  getPhrasesToday: () => {
    if (getAccessToken()) {
      return apiGlobal.authGet(reviseEndPoint.GET_PHRASES_TODAY, {})
    }
  },
  getQuestions: () => {
    if (getAccessToken()) {
      return apiGlobal.authGet(reviseEndPoint.GET_Questions, {})
    }
  },
  sendQuestionHistories: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authPost(
        reviseEndPoint.SEND_QUESTION_HISTORIES,
        params,
        {},
      )
    }
  },
  getSummary: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authGet(reviseEndPoint.SEND_QUESTION_HISTORIES, params)
    }
  },
  sendUserAudio: (data: any) => {
    if (getAccessToken()) {
      return apiGlobal.authPost(reviseEndPoint.AUDIO_MESSAGES, data, {}, true)
    }
  },
  getRetrieveTexts: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authPost(reviseEndPoint.RETRIEVE_TEXTS, params, {}, true)
    }
  },
  checkUserAnswer: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authPost(reviseEndPoint.CHECK_USER_ANSWERS, params, {})
    }
  },
}

export default reviseRequest
